import { render } from "./PageLeftRight.vue?vue&type=template&id=95f68a48"
import script from "./PageLeftRight.vue?vue&type=script&lang=js"
export * from "./PageLeftRight.vue?vue&type=script&lang=js"

import "./PageLeftRight.vue?vue&type=style&index=0&id=95f68a48&lang=scss"

import exportComponent from "E:\\_projekte\\PRIGNITZMUSEUM_HAVELBERG\\ARCHITEKTURSPUR\\release\\architekturspur\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__